import {
    UPDATE_PRODUCT_RESOURCE,
    UPDATE_PRODUCT_RESOURCE_FAILURE,
    UPDATE_PRODUCT_RESOURCE_SUCCESS,
} from 'store/actions/types';

export const updateProductResource = (payload) => {
    return {
        type: UPDATE_PRODUCT_RESOURCE,
        payload: payload,
    };
};

export const updateProductResourceFailure = (error) => {
    return {
        type: UPDATE_PRODUCT_RESOURCE_FAILURE,
        error: error,
    };
};

export const updateProductResourceSuccess = (payload, response) => {
    return {
        type: UPDATE_PRODUCT_RESOURCE_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/products/resource/updateProductResource.js